
































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import ParticaBaseForm from "../Base/ParticaBaseForm.vue";
import ParticaRowContainer from "@/Ui-Components/Common/Container/ParticaRowContainer.vue";
import ParticaColumnContainer from "@/Ui-Components/Common/Container/ParticaColumnContainer.vue";
import { FormFieldProps, FormFieldRules, IFormField } from "../../../Models/Components.model";
import { ParticaEvent } from "../../../Models/ParticaEvent";
import { ButtonConfig } from "../../../Models/Buttons";
import ButtonList from "../../Common/Buttons/ButtonList.vue";

@Component(
	{
		name: "ParticaDate",
		components: {
			ButtonList,
			ParticaRowContainer,
			ParticaColumnContainer
		}
	})
export default class ParticaDate extends Vue {
	@Prop() private buttons: ButtonConfig[];
	@Prop({ default: "Date" }) private name: string;
	@Prop() private value: Date;


	private dateconfig =
		{
			props: { name: "date", placeholder: "Choose date", label: "Date", } as FormFieldProps,
			rules: { required: true, } as FormFieldRules
		} as IFormField;
	private mdate: string = new Date().toISOString().substr(0, 10);
	private showpicker: boolean = false;

	private async buttonClicked(clicked: ParticaEvent) {
		this.$emit("partica-event", clicked);
	}

	@Watch("mdate")
	private setdate(date: string) {
		this.$emit("input", new Date(date));
	}
	private mounted(date: Date) {
		this.mdate = this.value.toISOString().substr(0, 10);
		this.dateconfig.props.name = this.name;
		this.dateconfig.props.label = this.name;
	}

}
